import e from "@babel/runtime/helpers/esm/objectSpread2";
import { sstyled as n } from "@semcore/utils/lib/core/index";
import o, { sstyled as i, assignProps as p } from "@semcore/core";
import g from "react";
import d from "../Box/index.mjs";
var c = (
  /*__reshadow_css_start__*/
  (n.insert(
    /*__inner_css_start__*/
    ".___SPattern_13gop_gg_{width:6px;height:100%;position:absolute;background-image:var(--intergalactic-border-critical-pattern, repeating-linear-gradient(315deg, rgba(209, 0, 47, 1) 0, rgba(209, 0, 47, 1) 2px, transparent 0, transparent 50%));background-size:6px 6px;background-color:var(--intergalactic-bg-primary-neutral, #ffffff);border-bottom-left-radius:var(--intergalactic-control-rounded, 6px);border-top-left-radius:var(--intergalactic-control-rounded, 6px)}",
    "13gop_gg_"
  ), {
    __SPattern: "___SPattern_13gop_gg_"
  })
), l = function() {
  var r = arguments[0], t, a = d;
  return t = i(c), /* @__PURE__ */ g.createElement(a, t.cn("SPattern", e({}, p({}, r))));
}, v = o(l);
export {
  v as InvalidStateBox,
  v as default
};
